import { render, staticRenderFns } from "./SureViewSupportModal.vue?vue&type=template&id=43cbb0e6&scoped=true&"
import script from "./SureViewSupportModal.vue?vue&type=script&lang=ts&"
export * from "./SureViewSupportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cbb0e6",
  null
  
)

export default component.exports